import React, { useEffect, useState } from 'react'
import { setGlobal, useGlobal } from 'reactn'

import { useNavigate } from 'react-router-dom'
import MedicalInstitutionList from 'ui/pages/admin/MedicalInstitutionList'
import { getMedicalInstitutionList, resendMail } from './fetch'
import { ApplicationEntryFormProps } from 'types/med'
import { routePaths } from 'app/routes'
import { Api401Error, NotFoundError } from 'app/client'
import { Layout } from 'ui/layout/Layout'
import { AppBarCommon } from 'ui/partials/AppBar'

const AdminMedicalInstitutionList: React.FC = () => {
  const navigate = useNavigate()

  const [error] = useGlobal('error')

  const [institutions, setInstitutions] = useState<ApplicationEntryFormProps[]>(
    []
  )

  useEffect(() => {
    getMedicalInstitutionList()
      .then((data) => {
        setInstitutions(data)
      })
      .catch((e) => {
        if (e instanceof NotFoundError) {
          navigate('/404')
          return
        }
        if (e instanceof Api401Error) {
          setGlobal({ error: 'forbidden' })
          return
        }
        navigate('/error')
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (error) {
    return <Layout header={<AppBarCommon />} />
  }

  return (
    <MedicalInstitutionList
      institutions={institutions}
      onClickEdit={(id) => {
        id && navigate(`${routePaths.admin}/edit/${String(id)}`)
      }}
      onResendMail={resendMail}
    />
  )
}

export default AdminMedicalInstitutionList
